import { Button } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import { useState } from "react";
import Message from "../message";

function YTScraper() {
  const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

  const [inputQuery, setInputQuery] = useState({ search_query: "", max_pages: "" });
  const [statusInputQuery, setStatusInputQuery] = useState("");

  const submit_inputQuery = async () => {
    setStatusInputQuery("");

    if (inputQuery["search_query"] === "") {
      setStatusInputQuery("Enter Search Term!");
    }
    else if (inputQuery["max_pages"] === "") {
      inputQuery["max_pages"] = "10";
    }
    else {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          search_query: inputQuery["search_query"],
          max_pages: inputQuery["max_pages"],
        }),
      };

      const requestUrl = apiServer + "api/yt_scraper/scrape_youtube";

      try {
        const response = await fetch(
          requestUrl,
          requestOptions
        );
        const inputQueryId = await response.json();
        const inputQueryStatus = inputQueryId.detail
          ? inputQueryId.detail
          : inputQueryId;
        setStatusInputQuery(inputQueryStatus);
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <TextField
        style={{ marginTop: "15px", width: "100%" }}
        value={inputQuery.search_query}
        onChange={(e) =>
          setInputQuery({ ...inputQuery, search_query: e.target.value })
        }
        id="outlined-basic"
        label="Search Term"
        variant="filled"
      />
      <TextField
        style={{ marginTop: "2px", width: "100%" }}
        value={inputQuery.max_pages}
        onChange={(e) =>
          setInputQuery({ ...inputQuery, max_pages: e.target.value })
        }
        id="outlined-basic"
        label="Max Pages"
        variant="filled"
      />
      <br/>
      <Button
        variant="primary"
        style={{ marginTop: "20px", width: "100%" }}
        onClick={() => submit_inputQuery()}
      >
        Submit
      </Button>
      {Message(statusInputQuery, setStatusInputQuery)}
    </div>
  );
}

export default YTScraper;
